import React from "react";
import { motion } from "framer-motion";
import { ASSETS } from "../../assetManifest.js";

interface IntroScreenProps {
  onStartGame: () => void;
}

const IntroScreen: React.FC<IntroScreenProps> = ({ onStartGame }) => (
  <div className="intro-screen h-full w-full bg-bg-main flex flex-col items-center justify-center p-4">
    <motion.div
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      className="text-center"
    >
      <img src={ASSETS.images.logo.path} alt="Coffee Break Logo" className="intro-logo w-48 h-48 mx-auto mb-4" />
      <h1 className="intro-title text-5xl font-bold text-text-primary">Coffee Break</h1>
      <p className="text-text-secondary mt-2 text-lg">Brew, Discover, and Serve Your Way to the Top!</p>
    </motion.div>
    <motion.button
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 0.5, duration: 0.5 }}
      onClick={onStartGame}
      className="mt-12 bg-primary-action text-white font-bold py-4 px-12 rounded-lg text-xl hover:bg-accent transition-all hover:scale-105 focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2 focus:ring-offset-bg-main"
    >
      Start Brewing
    </motion.button>
  </div>
);

export default IntroScreen;
